import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@envs/environment';
import { LoginUser } from '@shared/dto/login.user';
import { Observable } from 'rxjs';
import { RefreshData } from '@shared/dto/refresh.data';
import { TokenService } from './token.service';
import { LoginResponse } from '@shared/dto/auth/login-response';
import { InfoUsuarioResponse } from '@shared/dto/auth/info-usuario-response';

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    //Inyeccción dependencias
    private _httpClient = inject(HttpClient);
    private _tokenService = inject(TokenService);

    private static readonly API_URL = environment.API_URL.concat(environment.CW_AUTH).concat("/apimediador/siafpplus/servicioAuth");
    public static LOGIN_URL: string = `${AuthService.API_URL}/login/v2`;
    public static REFRESH_URL: string = `${AuthService.API_URL}/refresh-token/v1`;
    public static INFO_USUARIO_URL: string = `${AuthService.API_URL}/infoUsuario/v1`;

    login(data: LoginUser): Observable<LoginResponse> {
        return this._httpClient.post<LoginResponse>(AuthService.LOGIN_URL, data);
    }

    refreshToken(): Observable<RefreshData> {
        return this._httpClient.post<RefreshData>(AuthService.REFRESH_URL, { refreshToken: this._tokenService.getRefreshToken() });
    }

    onLogout(): void {
        this._tokenService.logout();
    }

    infoUsuario(username: string): Observable<InfoUsuarioResponse> {
        return this._httpClient.get<InfoUsuarioResponse>(`${AuthService.INFO_USUARIO_URL}/${username}`);
    }
}
